class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('aria-expanded', 'false');
    cartLink.setAttribute('aria-controls', 'CartDrawer');
    cartLink.addEventListener('click', (event) => {
      if (window.location.pathname != '/cart') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  getFocusTrapContainer() {
    return this.querySelector('.drawer__inner') || this;
  }

  getCloseButton() {
    if (this.classList.contains('is-empty')) {
      return (
        this.querySelector('#CartDrawer-Close-Empty') ||
        this.querySelector('.drawer__inner-empty .drawer__close') ||
        this.querySelector('.drawer__close')
      );
    }

    return this.querySelector('#CartDrawer-Close') || this.querySelector('.drawer__header .drawer__close') || this.querySelector('.drawer__close');
  }

  trapFocusOnCloseButton() {
    const container = this.getFocusTrapContainer();
    const closeButton = this.getCloseButton();
    trapFocus(container, closeButton || container);
  }

  setHeaderCartIconExpanded(expanded) {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) cartLink.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  togglePageInert(enable) {
    const drawerRoot = this.closest('#shopify-section-cart-drawer-root') || this;
    Array.from(document.body.children).forEach((child) => {
      if (child === drawerRoot || child.contains(this)) return;
      if (child.tagName === 'SCRIPT' || child.tagName === 'STYLE' || child.tagName === 'LINK') return;
      if (enable) {
        child.setAttribute('inert', '');
      } else {
        child.removeAttribute('inert');
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if (!this.activeElement) this.setActiveElement(document.activeElement);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    let focusMoved = false;
    const moveFocusIntoDrawer = () => {
      if (focusMoved) return;
      focusMoved = true;
      this.trapFocusOnCloseButton();
    };

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    const onTransitionEnd = (event) => {
      if (event.target !== this && event.target !== this.querySelector('.drawer__inner')) return;
      this.removeEventListener('transitionend', onTransitionEnd);
      moveFocusIntoDrawer();
    };
    this.addEventListener('transitionend', onTransitionEnd);
    setTimeout(() => {
      this.removeEventListener('transitionend', onTransitionEnd);
      moveFocusIntoDrawer();
    }, 350);

    this.setHeaderCartIconExpanded(true);
    this.togglePageInert(true);
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    this.setHeaderCartIconExpanded(false);
    this.togglePageInert(false);
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    const liveRegion = this.querySelector('#CartDrawer-LiveRegionText');
    if (liveRegion && window.cartStrings && window.cartStrings.itemAdded) {
      liveRegion.textContent = window.cartStrings.itemAdded;
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
